import React from 'react'

// Authenticated pages may be wrapped within this layout (for instance dashboard layout)
export const SharedStreamingLayout = ({ children }) => {
  return <div style={{ pointerEvents: 'none' }}>{children}</div>
}
